import React, {Component} from 'react';
import {AppBar, Grid, Toolbar, Typography} from 'material-ui';

class HeaderBar extends Component {
  getToolbarButton = type => {
    switch (type) {
      case 'add':
        return (
          <div
            className="line-it-button"
            data-lang="en"
            data-type="friend"
            data-lineid="@mwg8355z"
            data-count="true"
            style={{display: 'none'}}
          />
        );
      case 'share':
        return (
          <div
            className="line-it-button"
            data-lang="en"
            data-type="share-a"
            data-url={this.props.url}
            style={{display: 'none'}}
          />
        );
      default:
        return null;
    }
  };
  render() {
    return (
      <div style={{height: '100%', maxWidth: '100%'}}>
        <AppBar>
          <Toolbar>
            <Grid container justify="space-between">
              <Grid item>
                <Typography style={{color: 'white'}}>
                  {this.props.title}
                </Typography>
              </Grid>
              <Grid item>
                {this.getToolbarButton(this.props.button)}
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        <div style={{...this.props.bodyStyle, paddingTop: '64px'}}>{this.props.children}</div>
      </div>
    );
  }
}

export default HeaderBar;



// WEBPACK FOOTER //
// ./src/components/HeaderBar.js